<template>
  <div style="background: #fff" class="mt-3">
    <v-row class="text-center" style="margin-top: 3%">
      <v-col>
        <label for="profil-image-input" class="profile" style="cursor: pointer">
          <img
            class="circular--square"
            id="profil-image"
            :src="image_url+''+this.$store.getters.auth.image.cropped"
            alt=""
          /><br />
          <input
            type="file"
            name="image"
            @change="selectImage"
            style="display: none"
            id="profil-image-input"
            accept="image/*"
            ref="image"
          />
          <v-icon class="circle-icon" color="white">mdi-camera</v-icon>
          <div class="m-2" style="color: #29b3a6; font-weight: 700">
            Ajouter une photo
          </div>
        </label>
      </v-col>
    </v-row>
    <v-form ref="infoForm" v-model="infoFormValid">
      <v-container>
        <v-alert
          v-if="errors"
          dense
          outlined
          :type="errors.update_error ? 'error' : 'success'"
          >{{ $t(errors.message) }}</v-alert
        >
        <v-text-field
          v-if="submitting"
          color="primary"
          loading
          disabled
        ></v-text-field>

        <v-row>
          <v-col cols="12" sm="4">
            <v-text-field
              v-model="user._last_name"
              :label="$t('last_name')"
              single-line
              solo
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              v-model="user._first_name"
              :label="$t('first_name')"
              single-line
              solo
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              :rules="[rules.required, rules.email]"
              v-model="user._email"
              :label="$t('email')"
              single-line
              solo
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              v-model="user._phone"
              :rules="[rules.tel]"
              :label="$t('telephone')"
              single-line
              solo
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              v-model="user._address"
              :label="$t('address')"
              single-line
              solo
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-select
              :items="drop_down_countries"
              @change="countryChanged"
              id="country"
              name="country"
              v-model="country"
              solo
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              @click="updateInformations"
              :disabled="!infoFormValid"
              class="float-right"
              color="primary"
              >{{ $t("update") }}</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-divider></v-divider>
    <v-form v-model="passFormValid">
      <v-container>
        <v-alert
          v-if="errors_pass"
          dense
          outlined
          :type="errors_pass.update_error ? 'error' : 'success'"
          >{{ $t(errors_pass.message) }}</v-alert
        >
        <v-text-field
          v-if="submitting_pass"
          color="primary"
          loading
          disabled
        ></v-text-field>
        <v-row class="pl-5">
          <h4>{{ $t("update_password") }}</h4>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4">
            <v-text-field
              :append-icon="showOldPass ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.min]"
              :type="showOldPass ? 'text' : 'password'"
              @click:append="showOldPass = !showOldPass"
              :label="$t('old_password')"
              single-line
              solo
              v-model="old_password"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              v-model="password"
              :disabled="!getSetting('aucpw')"
              :append-icon="showNewPass ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.min]"
              :type="showNewPass ? 'text' : 'password'"
              @click:append="showNewPass = !showNewPass"
              :label="$t('new_password')"
              single-line
              solo
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              :disabled="!getSetting('aucpw')"
              :append-icon="showConfirmPass ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.min, rules.match]"
              :type="showConfirmPass ? 'text' : 'password'"
              @click:append="showConfirmPass = !showConfirmPass"
              :label="$t('confirm_password')"
              single-line
              solo
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              @click="updatePassword"
              :disabled="!passFormValid"
              class="float-right"
              color="primary"
              >{{ $t("update") }}</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import helpers from "@/mixins/helpers";
import {env} from '../../../../../env'
export default {
  name: "Profil",
  mixins: [helpers(this)],
  data() {
    return {
      translations: {
        countrySelectorLabel: "Code pays",
        countrySelectorError: "Choisir un pays",
        phoneNumberLabel: "Numéro de téléphone",
        example: "Exemple :",
      },
      image_url: env.image_base_url,
      phoneNumberIsValid: false,
      submitting: false,
      submitting_pass: false,
      showOldPass: false,
      showNewPass: false,
      showConfirmPass: false,
      passFormValid: false,
      infoFormValid: false,
      errors: undefined,
      errors_pass: undefined,
      countryHasChanged: false,
      email: "",
      rules: {
        required: (v) => !!v || this.$t("field_required"),
        min: (v) =>
          (!!v && v.length >= this.getSetting("nmcpw")) ||
          this.$t("min_8_caracters", { number: this.getSetting("nmcpw") }),
        match: (v) => v === this.password || this.$t("password_mismatch"),
        email: (v) =>
          v.match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) || this.$t("invalid_email"),
        tel: (v) =>
          v.match(/^[+]*[(]?[0-9]{1,4}[)]?[-\s/0-9]*$/g) ||
          this.$t("invalid_phone"),
        //email: v => (v.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) ||  this.$t('invalid_email'),
      },
      image: null,
      imageUrl: "images/faces/face2.jpg",
      password: "",
      old_password: "",
    };
  },
  computed: {
    user: function () {
      return this.$store.getters.auth;
    },

    country: function () {
      return this.user.country === null || this.user.country === undefined
        ? { text: "Votre pays", value: "1" }
        : { text: this.user.country._name, value: this.user.country._id };
    },
    drop_down_countries: function () {
      let arr = [];
      if (this.user.country) {
        console.log("comp user", this.user);
        arr.push({
          text: this.user.country._name,
          value: this.user.country._id,
        });
        console.log(arr);
      }
      if (this.countries) {
        this.countries.forEach((country) => {
          if (
            this.user.country === "undefined" ||
            country != null ||
            country._id !== this.user.country._id
          )
            arr.push({ text: country._name, value: country._id });
        });
      }

      return arr;
    },
    ...mapState("countries/", ["countries"]),
    ...mapState("generalsettings/", ["generals"]),
  },
  mounted() {
    this.$store.dispatch("countries/getCountries").then((response) => {
      console.log(response);
    });
  },
  methods: {
    /* eslint-disable*/
    selectImage(input, el) {
      this.image = this.$refs.image.files[0];
      let type = this.image.type;
      if (!type.includes("image")) {
        this.errors = {
          update_error: true,
          message: this.$t("invalid_file"),
        };

        return;
      }
      this.imageUrl = URL.createObjectURL(this.image);
      $("#profil-image").attr("src", this.imageUrl);
    },
    phoneNumberEntered(data) {
      // this.country_code = data.countryCode;
      // this.country_phone_code = data.countryCallingCode;
      this.phoneNumberIsValid =
        data.isValid && this.preferedCountries.includes(data.countryCode);
      this.user._phone = data.countryCallingCode + data.nationalNumber;
    },
    countryChanged() {
      this.countryHasChanged = true;
    },
    updateInformations() {
      let Self = this;
      let selectedCountry = $("input[name=country]").val();
      let data = new FormData();
      data.append("first_name", this.user._first_name);
      data.append("last_name", this.user._last_name);
      data.append("address", this.user._address);
      data.append("phone", this.user._phone);
      data.append("email", this.user._email);
      if (this.countryHasChanged) data.append("country", selectedCountry);
      if (this.image !== null) data.append("image", this.image);

      if (
        this.user._email === undefined ||
        this.user._email.trim().length === 0
      ) {
        return;
      }
      this.submitting = true;
      let responseObj = {};
      this.$store.dispatch("users/updateProfil", data).then((response) => {
        this.submitting = false;
        responseObj.update_error = response.error;
        responseObj.message = response.message;
        this.errors = responseObj;
        if (!response.error) {
          Self.toast("info", this.$t("profile_updated_reloading"));
          location.reload();
        }
      });
    },
    updatePassword() {
      if (!this.passFormValid) return;
      let responseObj = {};
      let data = new FormData();
      data.append("new_password", this.password);
      data.append("old_password_hash", this.user._password);
      data.append("old_password", this.old_password);
      this.submitting_pass = true;
      this.$store.dispatch("users/updatePassword", data).then((response) => {
        console.log(response);
        this.submitting_pass = false;
        responseObj.update_error = response.error;
        responseObj.message = response.message;
        this.errors_pass = responseObj;
      });
    },
  },
};
</script>

<style scoped>
.circle-icon {
  background: #29b3a6;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  margin-top: -30%;
  margin-left: 53%;
}
.circular--square {
  border-radius: 50%;
}
.circular--square {
  border-radius: 50% 50%;
  width: 170px;
  height: 170px;
  border: 1px solid gray;
  background: gray;
  object-fit: cover;
}
.img-icon-holder {
  margin-left: 60%;
  padding: 8px;
  background-color: #29b3a6;
  border-radius: 50%;
}
/*.circular--portrait {
        position: relative;
        width: 200px;
        height: 200px;
        overflow: hidden;
        border-radius: 50%;
    }

    .circular--portrait img {
        width: 100%;
        height: auto;
    }*/
</style>
